import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import ExploreOutlinedIcon from '@mui/icons-material/ExploreOutlined';
import AnimeIcon from '@mui/icons-material/TravelExploreOutlined';
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';
import LiveTvOutlinedIcon from '@mui/icons-material/LiveTvOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { preloadView } from '../preloadView.ts';

const items = [
  { id: 'home', label: 'Inicio', Icon: HomeOutlinedIcon },
  { id: 'anime', label: 'Anime', Icon: AnimeIcon },
  { id: 'explore', label: 'Manga', Icon: ExploreOutlinedIcon },
  { id: 'live', label: 'En vivo', Icon: LiveTvOutlinedIcon },
  { id: 'library', label: 'Biblioteca', Icon: BookmarkBorderOutlinedIcon },
  { id: 'more', label: 'Ajustes', Icon: SettingsOutlinedIcon },
];

export function YomiriMobileBottomNav({
  currentView,
  onNavigate,
}: {
  currentView: string;
  onNavigate: (view: string) => void;
}) {
  return (
    <Box
      component="nav"
      aria-label="Navegación móvil"
      sx={{
        display: { xs: 'flex', md: 'none' },
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        height: 'calc(50px + env(safe-area-inset-bottom))',
        pb: 'env(safe-area-inset-bottom)',
        bgcolor: 'rgba(15,20,28,0.96)',
        backdropFilter: 'blur(16px)',
        borderTop: '1px solid rgba(255, 255, 255, 0.08)',
        zIndex: 1100,
        px: 0.5,
        alignItems: 'center',
        justifyContent: 'space-around',
      }}
    >
      {items.map(({ id, label, Icon }) => {
        const active =
          currentView === id ||
          (id === 'explore' && ['sources'].includes(currentView)) ||
          (id === 'more' && ['about', 'downloads', 'appearance', 'history', 'updates'].includes(currentView));

        return (
          <ButtonBase
            key={id}
            aria-label={label}
            onPointerDown={() => preloadView(id)}
            onFocus={() => preloadView(id)}
            onClick={() => onNavigate(id)}
            aria-current={active ? 'page' : undefined}
            sx={{
              flex: 1,
              flexDirection: 'column',
              minWidth: 0,
              height: 48,
              gap: 0.3,
              borderRadius: '4px',
              color: active ? '#ffffff' : 'rgba(255, 255, 255, 0.55)',
              bgcolor: active ? 'rgba(255, 55, 95, 0.12)' : 'transparent',
              transition: 'background-color 0.15s ease, color 0.15s ease',
              '&:hover': {
                bgcolor: active ? 'rgba(255, 55, 95, 0.18)' : 'rgba(255, 255, 255, 0.04)',
                color: '#ffffff',
              },
            }}
          >
            <Icon sx={{ fontSize: 20, flexShrink: 0 }} />
            <Typography
              component="span"
              sx={{
                fontSize: 10,
                fontWeight: active ? 600 : 500,
                whiteSpace: 'nowrap',
                letterSpacing: '0.01em',
              }}
            >
              {label}
            </Typography>
          </ButtonBase>
        );
      })}
    </Box>
  );
}
